module.exports = __webpack_public_path__ + "media/images/success/check_green-1a589fb662514e1a9e3f0b9f30c21d3f.png";